import {base} from '../app'

export const arConfig = {
    ...base,
    bismi:'بِسۡمِ ٱللهِ ٱلرَّحۡمَـٰنِ ٱلرَّحِيمِ',
    salaam:'ٱلسَّلَامُ عَلَيْكُمْ وَرَحْمَةُ ٱللهِ وَبَرَكَاتُهُ',
    title :'Moshaf Akademy',
    logo : 'logo.png',

home : {
    login:'الدخول',
    about:'خدمة المصحف لقراءة وتعلم وحفظ القرآن الكريم في كل وقت وفي كل مكان',
    article : 'المقالات',
    contact : 'الاتصال',
},

blog: {
    read:'اقرأ المزيد...',
    title :'أكثر المقالات إثارة للاهتمام',
},

profile : {
    profile : 'ملفي',
    audio : 'الصوت',
    akademy : 'أكاديمي',
    iqrae:'ٱقۡرَأۡ',
    ihfad:'إحفظ',
    all:'كامل',
    search:'بحث',
    tadabbor:'تدبر',
    tilaawa:'تلاوة',
    tartyl:'ترتيل',
    aayaat:'آيات',
    nass:'النص',
    monitor:'مراقبة',
    akademyApp : 'تطبيق أكاديمي',
    setting : 'إعدادات',
    roles: [{Id:1, Value:'طالب'},{Id:2, Value:'معلم'},{Id:3, Value:'مدير'},{Id:4, Value:'إداري'}],
    salaam :'مرحبًا, ',
    contact:'اتصل بنا',
    service:'خدمات',
    logout:'الخروج',
    site:'الموقع',
    home:'الرئيسية',
    contact:'اتصل بنا',
    order:'الطلب',
    invoice:'الفواتير',
    login:'الدخول',
    admin:'إدارة'
},

contact:{
    title:'تواصل معنا',
    quote:'تأكيد الاتصال',
    message:'يرجى ملء النموذج أدناه لإرسال بريد إلكتروني إلينا',
    confirm:'تأكيد معلومات الاتصال',
    content:'يرجى ملء الكود الذي أرسلناه لك عبر البريد الإلكتروني لتأكيده',
    recipient:"يرجى تأكيد معلومات المستلم.",
    feedback : 'لقد تلقينا رسالتك، وسنقوم بالرد عليك في أقرب وقت ممكن',
    warning : 'يجب عليك تأكيد بريدك الإلكتروني قبل المتابعة',
},
}